import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import {of, Subject} from 'rxjs';
import {ElasticValidator, ElasticValidatorFactory} from 'asax-elastic';
import {debounceTime, mergeAll, tap} from 'rxjs/operators';
import {
  ChartFilter,
  ChartInput
} from '../frequency-view-chart-filters-container/frequency-view-chart-filters-container.component';

export const chartInputDebounceTime = 500;

@Component({
  selector: 'asax-frequency-view-frequency-view-chart-filter-lines',
  templateUrl: './frequency-view-chart-filter-lines.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FrequencyViewChartFilterLinesComponent implements OnInit, OnChanges {
  @Input() value: string;
  @Input() chartInput: ChartInput;

  @Output() outFilter = new EventEmitter<ChartFilter>();

  isInvalid: boolean;
  errorMessage: string;

  valueSubject = new Subject<string>();
  valueSubjectWithDebounceTime = new Subject<string>();
  elasticValidator: ElasticValidator;

  constructor(private readonly elasticValidatorFactory: ElasticValidatorFactory,
              private readonly ref: ChangeDetectorRef) {
  }

  ngOnInit(): void {
    this.elasticValidator = this.elasticValidatorFactory.getElasticValidator(this.chartInput.elasticValidatorType);

    of(
      this.valueSubjectWithDebounceTime.asObservable().pipe(debounceTime(chartInputDebounceTime)),
      this.valueSubject.asObservable()
    ).pipe(
      mergeAll(),
      tap(() => this.validateValue()),
      tap(() => this.emitFilter())
    ).subscribe();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.value && this.value !== undefined && this.value != null) {
      this.valueChanged();
    }
  }

  valueChangedWithDebounceTime(): void {
    this.valueSubjectWithDebounceTime.next(undefined);
  }

  valueChanged(): void {
    this.valueSubject.next(undefined);
  }

  validateValue(): void {
    this.isInvalid = undefined;

    if (this.value?.length && this.elasticValidator) {
      const {isInvalid, errorMessage} = this.elasticValidator.validate(this.value);
      this.isInvalid = isInvalid;
      this.errorMessage = errorMessage;
    }

    this.ref.markForCheck();
  }

  clearChartInputValue(): void {
    this.value = '';
    this.valueChanged();
  }

  onExampleClick(example: string): void {
    this.value = example;
    this.valueChanged();
  }

  emitFilter(): void {
    const filter = {
      id: this.chartInput.id,
      value: this.value,
      valueParsed: this.value,
      valueToDisplay: this.value,
      label: this.chartInput.label,
      isInvalid: this.isInvalid,
      elasticParserType: this.chartInput.elasticParserType
    };

    this.outFilter.emit(filter);
  }
}
